import React, {Component} from "react";
import {ClickAwayListener, Grid, TextField, Typography} from "@mui/material";
import {updateSlide} from "../../../redux_actions/maps.state.action";
import {Tooltip} from "antd";
import {store} from "../../../helper/store";
import {notifyError} from "../utils/display.notification";
import { aclPermissions, hasPermissions } from "const/ACLPermissions";

class SlideName extends Component {

	constructor(props) {
		super(props);

		this.state = {
			edit: false,
			name: this.props.slide.name,    // putting in local state to avoid backend lag
		}
		this.maxCharacters = this.props.maxCharacters || 20;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.slide.name !== prevProps.slide.name) {
			this.setState({
				name: this.props.slide.name
			})
		}
	}

	editSlideName = () => {
		if (!hasPermissions([aclPermissions.update_slides_name])) return
		this.setState({ edit: true })
	}

	clickAway = () => {
		this.state.name ?
			store.dispatch(updateSlide(this.props.mapId, this.props.slide.id, {
				name: this.state.name,
			})) : notifyError("SlideName", "Slide name cannot be empty");
		this.setState({
			name: this.state.name || this.props.slide.name,   // if empty name, revert to previous name
			edit: false,
		});
	}

	getComponent = () =>
		!this.state.edit ? <Tooltip
				title={hasPermissions([aclPermissions.update_slides_name]) ?
					"Click to edit slide name" : "Slide Name"} placement={"bottom"}>
				<Grid
					sx={{width: Math.min(this.state.name.length, this.maxCharacters) * 10, justifyContent: 'center', textAlign: "center", paddingTop: "5px"}}
					onClick={this.editSlideName}>
					<Typography color={'text.primary'}>
						{this.state.name.slice(0, this.maxCharacters) +
						(this.state.name.length > this.maxCharacters ? '...' : '')}
					</Typography>
				</Grid>
			</Tooltip> :
			<ClickAwayListener onClickAway={this.clickAway}>
				<TextField value={this.state.name} color='secondary' margin='normal' variant="filled"
				           size="small" onChange={e => this.setState({name: e.target.value})} autoFocus
				           onKeyDown={(e) => e.keyCode === 13 ? this.clickAway(e) : e.stopPropagation()}
				           sx={{
					           px: 1, width: Math.min(this.state.name.length, this.maxCharacters) * 12,
					           backgroundColor: '#0b1c3b',
							   paddingTop: "5px"
				        	}}
				/>
			</ClickAwayListener>


	render() {
		return <Grid item xs={7} style={{fontWeight: 300}} className="scanslidename-forTour">
				{this.getComponent()}
			</Grid>
	}
}

export default SlideName;
